import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const SuitesPage = lazy(() => import('./pages/SuitesPage'));

export const SuitesRoutes: RouteObject = {
  path: 'suites',
  children: [
    { path: '', element: <SuitesPage />, handle: { crumb: 'Suites & Modules' } },
  ],
};
